<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col align="center" justify="center">
        <h1>回饋問卷</h1>
      </v-col>
    </v-row>
    <!--    family members-->
    <v-row v-for="(member, idx) in members" :key="member.id" dense>
      <v-col align="center" justify="center">
        <v-card
            class="mx-auto"
            max-width="344"
            outlined
            @click="toDetailsView(member.id)"
        >


          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">
                {{member.name}}
              </v-list-item-title>
              <v-list-item-subtitle>填寫專屬於{{member.name}}小朋友的問卷</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

        </v-card>
      </v-col>

    </v-row>

    <br/><br/><br/>
    <br/><br/><br/>

  </v-container>
</template>

<script>
// @ is an alias to /src

let api_url = process.env.VUE_APP_API_URL;

export default {
  name: "Review",
  data() {
    return {
      members: []
    };
  },
  computed: {
    isLiffReady() {
      return this.$store.state.accessToken
    }
  },
  watch: {
    isLiffReady(newValue, oldValue) {
      console.log('isLiffReady changed to ', newValue);
      this.getFamilyMembers();

    }
  },
  mounted() {
    // console.log(this.books);
    // this.pickBooksRandom(4);
    this.getFamilyMembers();
  },
  methods: {
    getFamilyMembers() {
      this.members = []
      var data = JSON.stringify({access_token: this.$store.state.accessToken});
      var xhr = new XMLHttpRequest();
      this.recommendedBooks = [];
      xhr.addEventListener("readystatechange", () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {
            console.log(result);
            result.forEach((member) => {
              this.members.push(member);
            });
          } else {
            // alert(result.error.message);
          }
        }
      });

      xhr.open(
          "POST",
          api_url +
          "/api/books/" +
          this.$store.state.userId +
          "/family_members/"
      );

      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    },
    toDetailsView(memberId) {
      this.$router.push("/review/" +memberId)
    },
  },
};
</script>

<style>
</style>